import { render, staticRenderFns } from "./ambassador-manage.vue?vue&type=template&id=0057e886&scoped=true&"
import script from "./ambassador-manage.vue?vue&type=script&lang=js&"
export * from "./ambassador-manage.vue?vue&type=script&lang=js&"
import style0 from "./ambassador-manage.vue?vue&type=style&index=0&id=0057e886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057e886",
  null
  
)

export default component.exports